document.addEventListener('DOMContentLoaded', function() {
    const pageSize = 12; // Set the page size
    let currentPage = 1;
    let sortedProducts = [];
  
    const buttonLoader = document.getElementById('button-loader');
    const resultsLoader = document.getElementById('results-loader');
    const tableHeaders = document.querySelector('#products-table thead'); // Table headers
    const summaryContainer = document.getElementById('search-summary-container');
    //const summaryContainerWrap = document.getElementById('search-summary-container-wrapper');
  
    // Initially hide table headers
    if (tableHeaders) {
      tableHeaders.classList.add('hidden');
    }
  
    document.getElementById('product-search-form').addEventListener('submit', async function(event) {
      event.preventDefault();
  
      // Reset search summary on each submit
      summaryContainer.innerHTML = '';
  
      if (buttonLoader) {
        buttonLoader.classList.remove('loader-hidden');
      }
      if (resultsLoader) {
        resultsLoader.classList.remove('loader-hidden');
      }
  
      const selectElement = document.getElementById('collection');
      if (selectElement.selectedOptions.length === 0) {
        alert('Please select at least one collection before submitting the form.');
        return; // Stop further execution if no collection is selected
      }
  
      const quantityOrMore = document.getElementById('quantityOrMore').checked;
      const initialQuantityInput = parseInt(document.getElementById('quantity').value, 10);
      const maxSpend = parseFloat(document.getElementById('maxSpend').value);
      console.log(`Form Values - Quantity: ${initialQuantityInput}, Max Spend: ${maxSpend}`);
  
      const selectedCollections = Array.from(selectElement.selectedOptions).map(option => option.value.trim().toLowerCase());
      const selectedDecorations = Array.from(document.getElementById('decoration').selectedOptions).map(option => option.value.trim().toLowerCase());
  
      // Add this check for empty decoration selection
      const showAllVariants = selectedDecorations.length === 0;
  
      let allProducts = [];
  
      // Function to fetch products for a single collection
      async function fetchProductsForCollection(handle) {
        let cursor = null;
        let hasNextPage = true;
        let products = [];
  
        while (hasNextPage) {
          const query = `
            query getProductsByCollectionHandle($handle: String!, $cursor: String) {
              collectionByHandle(handle: $handle) {
                products(first: 250, after: $cursor) {
                  edges {
                    node {
                      id
                      title
                      onlineStoreUrl
                      featuredImage {
                        url
                      }
                      variants(first: 100) {  
                        edges {
                          node {
                            id
                            title
                            price {
                              amount
                            }
                          }
                        }
                      }
                      metafields(identifiers: [
                        { key: "volume_discounts", namespace: "custom" },
                        { key: "delivery_in_weeks", namespace: "custom" },
                        { key: "minqty", namespace: "big" }
                      ]) {
                        key
                        value
                      }
                    }
                  }
                  pageInfo {
                    hasNextPage
                    endCursor
                  }
                }
              }
            }
          `;
  
          try {
            const response = await fetch('https://promo-punks.myshopify.com/api/2023-07/graphql.json', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': '1fc39b01a2aa952160db37c81bd5fe6d',
              },
              body: JSON.stringify({
                query,
                variables: {
                  handle: handle,
                  cursor: cursor,
                },
              }),
            });
  
            const result = await response.json();
  
            if (result.errors) {
              console.error('GraphQL Errors:', result.errors);
              alert('There was an error with your request. Please check the console for details.');
              return [];
            }
  
            if (!result.data || !result.data.collectionByHandle) {
              console.error('Collection not found:', result.data);
              return [];
            }
  
            const fetchedProducts = result.data.collectionByHandle.products.edges;
            products = [...products, ...fetchedProducts];
  
            hasNextPage = result.data.collectionByHandle.products.pageInfo.hasNextPage;
            cursor = result.data.collectionByHandle.products.pageInfo.endCursor;
          } catch (error) {
            console.error('Fetch error:', error);
            alert('An error occurred while fetching products. Please try again later.');
            return [];
          }
        }
  
        return products;
      }
  
      // Fetch products for each selected collection
      for (const handle of selectedCollections) {
        const productsForCollection = await fetchProductsForCollection(handle);
        allProducts = [...allProducts, ...productsForCollection];
      }
  
      console.log(`Total Products Fetched: ${allProducts.length}`);
  
      function calculateMaxQuantityWithDiscount(basePrice, maxSpend, discountTiers) {
        let bestQuantity = 0;
        let bestPrice = basePrice;
        let bestTotalCost = 0;
        let applicableDiscount = null;
  
        // Sort discount tiers by quantity in ascending order
        const sortedTiers = discountTiers.sort((a, b) => b.discountQuantity - a.discountQuantity);
        console.log('Sorted Discount Tiers:', sortedTiers);
  
        for (let i = 0; i < sortedTiers.length; i++) {
          const tier = sortedTiers[i];
          const discountedPrice = basePrice * (1 - tier.discountPercentage / 100);
          const potentialQuantity = Math.floor(maxSpend / discountedPrice);
          const potentialTotalCost = potentialQuantity * discountedPrice;
  
          if (potentialTotalCost <= maxSpend && potentialQuantity >= tier.discountQuantity) {
            bestQuantity = potentialQuantity;
            bestPrice = discountedPrice;
            bestTotalCost = potentialTotalCost;
            applicableDiscount = tier;
            break; // Stop once the best discount tier is found
          }
        }
  
        // Check without any discount
        const noDiscountQuantity = Math.floor(maxSpend / basePrice);
        const noDiscountTotalCost = noDiscountQuantity * basePrice;
        if (noDiscountTotalCost <= maxSpend && noDiscountQuantity > bestQuantity) {
          bestQuantity = noDiscountQuantity;
          bestPrice = basePrice;
          bestTotalCost = noDiscountTotalCost;
          applicableDiscount = null;
        }
  
        //console.log(`Base Price: ${basePrice}, Max Spend: ${maxSpend}, Best Quantity: ${bestQuantity}, Best Price: ${bestPrice}, Best Total Cost: ${bestTotalCost}`);
  
        return {
          finalQuantity: bestQuantity,
          finalPrice: bestPrice,
          finalTotalCost: bestTotalCost,
          applicableDiscount: applicableDiscount
        };
      }
  
      sortedProducts = allProducts.flatMap(({ node }) => {
        const metafields = Array.isArray(node.metafields) ? node.metafields.filter(Boolean) : [];
        const volumeDiscountsMetafield = metafields.find(mf => mf?.key === "volume_discounts");
        const volumeDiscounts = volumeDiscountsMetafield ? volumeDiscountsMetafield.value : null;
        const deliveryTimeMetafield = metafields.find(mf => mf?.key === "delivery_in_weeks");
        const deliveryTime = deliveryTimeMetafield ? deliveryTimeMetafield.value : "N/A";
        
        // Extract minqty
        const minQtyMetafield = metafields.find(mf => mf?.key === "minqty");
        const minQty = minQtyMetafield ? parseInt(minQtyMetafield.value, 10) : 0;
  
        // Check minimum quantity requirement
        if (quantityOrMore) {
          // For "or more" case, we'll check the minimum quantity later
          // after calculating the maximum possible quantity
        } else {
          // For exact quantity case, check against the initial input
          if (minQty > initialQuantityInput) {
            //console.log(`Filtered out product ${node.title} because minQty ${minQty} is greater than initialQuantityInput ${initialQuantityInput}`);
            return []; // Skip this product if it doesn't meet the minimum quantity
          }
        }
  
        // Modify this part to handle all variants when no decoration is selected
        return (showAllVariants ? node.variants.edges : node.variants.edges.filter(({ node: variant }) => {
          const variantTitle = variant.title.trim().toLowerCase();
          return selectedDecorations.includes(variantTitle);
        }))
        .map(({ node: variant }) => {
          let price = parseFloat(variant.price.amount);
          let discountedPrice = price;
          let applicableDiscount = null;
          let finalQuantity = initialQuantityInput; // Define finalQuantity here
  
          const discountTiers = volumeDiscounts
            ? volumeDiscounts
                .replace(/\\/g, '')
                .replace(/[\[\]'"]/g, '')
                .split(',')
                .map(item => {
                  const [discountQuantity, discountPercentage] = item.split(':').map(Number);
                  return { discountQuantity, discountPercentage };
                })
            : [];
  
          // Ensure discount tiers are sorted in descending order by discountQuantity
          const sortedTiers = discountTiers.sort((a, b) => b.discountQuantity - a.discountQuantity);

          if (quantityOrMore) {
            // Existing logic for 'and more' case
            const result = calculateMaxQuantityWithDiscount(price, maxSpend, sortedTiers);
            finalQuantity = result.finalQuantity;
            discountedPrice = result.finalPrice;
            const finalTotalCost = result.finalTotalCost;
            applicableDiscount = result.applicableDiscount;

            if (finalQuantity < minQty || finalQuantity < initialQuantityInput) {
              console.log(`AM: Filtered out product ${node.title} because final quantity ${finalQuantity} is less than minQty ${minQty}. Regular Price: ${price}, Discounted Price: ${discountedPrice}`);
              return null; // Skip this product if it doesn't meet the minimum quantity
            }
          } else {
            // Logic for exact quantity case
            applicableDiscount = sortedTiers.find(tier => tier.discountQuantity <= initialQuantityInput);
            if (applicableDiscount) {
              discountedPrice = price * (1 - applicableDiscount.discountPercentage / 100);
            }

            const discountedTotalCost = discountedPrice * initialQuantityInput;
            if (minQty > initialQuantityInput || discountedTotalCost > maxSpend) {
              console.log(`Filtered out product ${node.title} because minQty ${minQty} is greater than initialQuantityInput ${initialQuantityInput} or total cost ${discountedTotalCost} exceeds maxSpend ${maxSpend}.`);
              return null; // Skip this product if it doesn't meet the minimum quantity or exceeds max spend
            }
          }

          const discountInfo = applicableDiscount
            ? `${applicableDiscount.discountQuantity} units at ${applicableDiscount.discountPercentage}% off`
            : '';

          return {
            title: node.title,
            id: node.id,
            price: price,
            discountedPrice: discountedPrice,
            originalPrice: price,
            quantity: finalQuantity,
            totalCost: discountedPrice * finalQuantity,
            discountTier: discountInfo,
            discountPercentage: applicableDiscount ? applicableDiscount.discountPercentage : null,
            deliveryTime,
            productUrl: node.onlineStoreUrl,
            selectedDecorationTitle: variant.title,
            imageUrl: node.featuredImage ? node.featuredImage.url : '',
            variantId: variant.id.split('/').pop() // Extract numeric ID from GID
          };
        })
        .filter(Boolean);
      });
  
      console.log(`Total Products Filtered: ${sortedProducts.length}`);
  
      // Sort products by 'Quantity' when "or more" is checked, otherwise by total cost
      if (quantityOrMore) {
        sortedProducts.sort((a, b) => b.quantity - a.quantity);
      } else {
        sortedProducts.sort((a, b) => b.totalCost - a.totalCost);
      }
  
      if (buttonLoader) {
        buttonLoader.classList.add('loader-hidden');
      }
      if (resultsLoader) {
        resultsLoader.classList.add('loader-hidden');
      }
  
      // Display the first page of results
      currentPage = 1;
      displayResults(paginateProducts(sortedProducts), sortedProducts.length);
      updatePaginationControls(Math.ceil(sortedProducts.length / pageSize));



     
    });
  
    function paginateProducts(products) {
      const startIndex = (currentPage - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      return products.slice(startIndex, endIndex);
    }
  
    function displayResults(products, totalFiltered) {
      const tbody = document.querySelector('#products-table tbody');
      const noResultsMessage = document.getElementById('no-results-message');
      const productsTable = document.getElementById('products-table');
      const paginationControls = document.getElementById('pagination-controls');

      if (!tbody || !summaryContainer) {
        console.error('Table or summary container not found in the DOM.');
        return;
      }

      // Show/hide elements based on search results
      if (products.length === 0) {
        showNoResults(noResultsMessage, productsTable, paginationControls);
        return;
      } else {
        hideNoResults(noResultsMessage, productsTable, paginationControls);
      }

      if (currentPage === 1) {
        // Add "Search Results" text only once
        if (summaryContainer.innerHTML === '') {
          const summary = document.createElement('div');
          summary.classList.add('search-results-summary');
          summary.textContent = `Search Results: ${totalFiltered}`;
          summaryContainer.appendChild(summary);
          //summaryContainerWrap.style.display = 'flex';
        }
      }
  
      tbody.innerHTML = '';
  
      // Show table headers when content is displayed
      if (tableHeaders) {
        tableHeaders.classList.remove('hidden');
      }
  
      products.forEach(product => {
        const discountInfo = product.discountPercentage
          ? `<span class="discount-info">${product.discountPercentage}% off</span>`
          : '';
  
        // Truncate the product title if it's longer than 20 characters
        const truncatedTitle = product.title.length > 20 
          ? product.title.substring(0, 20) + '...' 
          : product.title;
  
        // Extract numeric ID from GID
        const numericVariantId = product.variantId.split('/').pop();
  
        const row = document.createElement('tr');
        row.innerHTML = `
          <td class="th-title"><img src="${product.imageUrl}" alt="${truncatedTitle}"><a href="${product.productUrl}" target="_blank" title="${product.title}">${truncatedTitle} <img src="https://cdn.shopify.com/s/files/1/0741/3376/6426/files/external-link.png?v=1725490137" style="width: 12px; height: 12px; margin-left: 4px; margin-top: -3px"></a></td>
          <td>$${product.totalCost.toFixed(2)}</td>
          <td>${product.quantity}</td>
          <td>$${product.discountedPrice.toFixed(2)}</td>
          <td>${discountInfo}</td>
          <td>${product.selectedDecorationTitle}<br><a data-fancybox data-src="#product-details-modal" href="javascript:;" class="view-details-btn" data-product-id="${product.id}">more options</a></td>
          <td>within ${product.deliveryTime} weeks</td>
          <td><button class="add-to-cart-btn" data-variant-id="${numericVariantId}" data-quantity="${product.quantity}" ><img src="https://cdn.shopify.com/s/files/1/0741/3376/6426/files/cal-icon.svg?v=1725318603"></button></td>
        `;
        tbody.appendChild(row);
      });
  
      // Add event listeners to "Add to Cart" buttons
      document.querySelectorAll('.add-to-cart-btn').forEach(button => {
        button.addEventListener('click', handleAddToCart);
      });
  
      // Disable sorting headers on pages beyond the first
      document.querySelectorAll('#products-table th[data-sort]').forEach(th => {
        if (currentPage > 1) {
          th.classList.add('inactive');
          th.style.cursor = 'default';
        } else {
          th.classList.remove('inactive');
          th.style.cursor = 'pointer';
        }
      });
  
      setupViewDetailsButtons();
    }
  
    function updatePaginationControls(totalPages) {
      const paginationContainer = document.getElementById('pagination-controls');
      paginationContainer.innerHTML = '';
  
      if (totalPages <= 1) return; // No need to show pagination controls if there's only one page
  
      const createButton = (text, disabled, onClick) => {
        const button = document.createElement('button');
        button.textContent = text;
        button.disabled = disabled;
        button.addEventListener('click', onClick);
        return button;
      };
  
      const addPageButton = (page) => {
        const pageButton = createButton(page, page === currentPage, () => {
          currentPage = page;
          displayResults(paginateProducts(sortedProducts), sortedProducts.length);
          updatePaginationControls(totalPages);
          scrollToTable(); // Scroll to the top of the table
        });
        pageButton.classList.toggle('active', page === currentPage);
        paginationContainer.appendChild(pageButton);
      };
  
      // First and Previous buttons
      paginationContainer.appendChild(createButton('First', currentPage === 1, () => {
        currentPage = 1;
        displayResults(paginateProducts(sortedProducts), sortedProducts.length);
        updatePaginationControls(totalPages);
        scrollToTable();
      }));
      paginationContainer.appendChild(createButton('Previous', currentPage === 1, () => {
        if (currentPage > 1) {
          currentPage--;
          displayResults(paginateProducts(sortedProducts), sortedProducts.length);
          updatePaginationControls(totalPages);
          scrollToTable();
        }
      }));
  
      // Page buttons with ellipsis
      const maxPageButtons = 5;
      const halfRange = Math.floor(maxPageButtons / 2);
      let startPage = Math.max(1, currentPage - halfRange);
      let endPage = Math.min(totalPages, currentPage + halfRange);
  
      if (currentPage <= halfRange) {
        endPage = Math.min(totalPages, maxPageButtons);
      } else if (currentPage + halfRange >= totalPages) {
        startPage = Math.max(1, totalPages - maxPageButtons + 1);
      }
  
      if (startPage > 1) {
        addPageButton(1);
        if (startPage > 2) {
          paginationContainer.appendChild(document.createTextNode('...'));
        }
      }
  
      for (let i = startPage; i <= endPage; i++) {
        addPageButton(i);
      }
  
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          paginationContainer.appendChild(document.createTextNode('...'));
        }
        addPageButton(totalPages);
      }
  
      // Next and Last buttons
      paginationContainer.appendChild(createButton('Next', currentPage === totalPages, () => {
        if (currentPage < totalPages) {
          currentPage++;
          displayResults(paginateProducts(sortedProducts), sortedProducts.length);
          updatePaginationControls(totalPages);
          scrollToTable();
        }
      }));
      paginationContainer.appendChild(createButton('Last', currentPage === totalPages, () => {
        currentPage = totalPages;
        displayResults(paginateProducts(sortedProducts), sortedProducts.length);
        updatePaginationControls(totalPages);
        scrollToTable();
      }));
    }
  
    // Function to scroll to the table
    function scrollToTable() {
      const tableElement = document.getElementById('products-table');
      if (tableElement) {
        tableElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  
    // Sorting Logic
    document.querySelectorAll('#products-table th[data-sort]').forEach(th => {
      th.addEventListener('click', () => {
        // Prevent sorting on pages beyond the first
        if (currentPage > 1) return;
  
        const sortKey = th.getAttribute('data-sort');
        
        // Remove sort classes from other headers
        document.querySelectorAll('#products-table th[data-sort]').forEach(header => {
          if (header !== th) {
            header.classList.remove('sort-asc', 'sort-desc');
          }
        });
  
        // Toggle sort direction on the clicked header
        let isAscending;
        if (th.classList.contains('sort-asc')) {
          th.classList.remove('sort-asc');
          th.classList.add('sort-desc');
          isAscending = false;
        } else if (th.classList.contains('sort-desc')) {
          th.classList.remove('sort-desc');
          th.classList.add('sort-asc');
          isAscending = true;
        } else {
          th.classList.add('sort-asc');
          isAscending = true;
        }
  
        // Sort the entire dataset before paginating
        sortedProducts = sortedProducts.sort((a, b) => {
          let cellA, cellB;
  
          if (sortKey === 'name') {
            // For product name, use the 'title' property and localeCompare for proper string comparison
            cellA = a.title.toLowerCase();
            cellB = b.title.toLowerCase();
            return isAscending ? cellA.localeCompare(cellB) : cellB.localeCompare(cellA);
          } else if (sortKey === 'price') {
            // For price, use the discounted price
            cellA = a.discountedPrice;
            cellB = b.discountedPrice;
          } else if (sortKey === 'totalCost') {
            // For total cost, use the totalCost property
            cellA = a.totalCost;
            cellB = b.totalCost;
          } else if (sortKey === 'quantity') {
            // For quantity, use the quantity property
            cellA = a.quantity;
            cellB = b.quantity;
            } else if (sortKey === 'discount') {
            // For discount, use the discountPercentage property
            cellA = a.discountPercentage || 0;
            cellB = b.discountPercentage || 0;
          } else {
            // For other fields, use the existing string comparison
            cellA = a[sortKey].toString().toLowerCase();
            cellB = b[sortKey].toString().toLowerCase();
          }

          
  
          // Numeric comparison for price, totalCost, and quantity
          if (typeof cellA === 'number' && typeof cellB === 'number') {
            return isAscending ? cellA - cellB : cellB - cellA;
          } else {
            // String comparison for other fields
            return isAscending ? cellA.localeCompare(cellB) : cellB.localeCompare(cellA);
          }
        });
  
        currentPage = 1; // Reset to first page after sorting
        displayResults(paginateProducts(sortedProducts), sortedProducts.length);
        updatePaginationControls(Math.ceil(sortedProducts.length / pageSize));
      });
    });
  
    // Add to Cart Functionality
    async function handleAddToCart(event) {
      const button = event.currentTarget;
      const variantId = button.getAttribute('data-variant-id');
      const quantity = parseInt(button.getAttribute('data-quantity'), 10);
  
      if (!variantId || !quantity) {
        console.error('Variant ID or quantity is missing.');
        return;
      }
  
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: quantity
            }]
          })
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          console.error('Add to Cart error:', errorData);
          alert('There was an error adding the item to the cart. Please try again.');
          return;
        }
  
        const cartData = await response.json();
        console.log('Cart updated:', cartData);
        // Optionally, redirect to the cart or update cart UI
        window.location.href = '/cart';
      } catch (error) {
        console.error('Fetch error:', error);
        alert('An error occurred while adding the item to the cart. Please try again.');
      }
    }
  
    function setupViewDetailsButtons() {
      document.querySelectorAll('.view-details-btn').forEach(button => {
        button.addEventListener('click', function (event) {
          event.preventDefault(); // Prevent default action to avoid any conflicts
          const productId = button.getAttribute('data-product-id');
          const quantityInput = document.getElementById('quantity'); // Get the quantity input element
          const quantity = quantityInput ? quantityInput.value : 1; // Retrieve quantity value (default to 1 if not found)
  
          fetchProductDetails(productId, quantity).then(product => {
            if (product) {
              populateModalContent(product, quantity);
              // Ensure Fancybox is triggered only once
              Fancybox.show([{ src: '#product-details-modal', type: 'inline' }]);
            } else {
              console.error('Failed to load product details.');
            }
          });
        });
      });
    }
  
    // Function to fetch product details from the Shopify Storefront API
    function fetchProductDetails(productId, quantity) {
      const query = `
        query getProductDetails($id: ID!) {
          product(id: $id) {
            title
            handle
            featuredImage {
              url
            }
            metafields(identifiers: [
              { key: "volume_discounts", namespace: "custom" },
              { key: "delivery_in_weeks", namespace: "custom" }
            ]) {
              key
              value
            }
            variants(first: 100) {
              edges {
                node {
                  id
                  title
                  price {
                    amount
                  }
                }
              }
            }
          }
        }
      `;
  
      return fetch('https://promo-punks.myshopify.com/api/2023-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '1fc39b01a2aa952160db37c81bd5fe6d',
        },
        body: JSON.stringify({
          query,
          variables: { id: productId },
        }),
      })
        .then(response => response.json())
        .then(data => {
          if (!data || !data.data || !data.data.product) {
            console.error('No product data returned:', data);
            return null;
          }
  
          const product = data.data.product;
  
          // Extract metafields
          let volumeDiscounts = '';
          let deliveryTime = 'N/A';
  
          if (product.metafields && Array.isArray(product.metafields)) {
            product.metafields.forEach(metafield => {
              if (metafield && metafield.key === 'volume_discounts') {
                volumeDiscounts = metafield.value;
              } else if (metafield && metafield.key === 'delivery_in_weeks') {
                deliveryTime = metafield.value;
              }
            });
          }
  
          // Process variants and apply discount logic
          const variants = product.variants.edges.map(edge => {
            const variant = edge.node;
            let discountedPrice = parseFloat(variant.price.amount);
            let discountPercentage = null;
  
            if (volumeDiscounts && volumeDiscounts !== "[]") {
              const cleanedValue = volumeDiscounts
                .replace(/\\/g, '')
                .replace(/[\[\]'"]/g, '');
  
              const discounts = cleanedValue
                .split(',')
                .map(item => {
                  const [discountQuantity, discountPercentage] = item.split(':').map(Number);
                  return { discountQuantity, discountPercentage };
                });
  
              const applicableDiscount = discounts
                .filter(discount => discount.discountQuantity <= quantity)
                .sort((a, b) => a.discountQuantity - b.discountQuantity)[0];
  
              if (applicableDiscount) {
                discountedPrice = discountedPrice * (1 - applicableDiscount.discountPercentage / 100);
                discountPercentage = applicableDiscount.discountPercentage;
              }
            }
  
            return {
              id: variant.id,
              title: variant.title,
              price: parseFloat(variant.price.amount),
              discountedPrice,
              discountPercentage,
              totalCost: discountedPrice * quantity,
              deliveryTime,
            };
          });
  
          return {
            title: product.title,
            handle: product.handle,
            imageUrl: product.featuredImage?.url || '',
            variants,
          };
        })
        .catch(error => {
          console.error('Error fetching product details:', error);
          return null;
        });
    }
  
    // Function to populate the modal with fetched product details
    function populateModalContent(product, quantity) {
      document.getElementById('modal-product-title').textContent = product.title;
      document.getElementById('modal-product-image').src = product.imageUrl;
  
      const productUrl = `/products/${product.handle}`;
      document.getElementById('modalbtn').href = productUrl;
  
      const variantsTableBody = document.getElementById('variants-table').querySelector('tbody');
      variantsTableBody.innerHTML = '';
  
      product.variants.forEach(variant => {
        const discountInfo = variant.discountPercentage
          ? ` <span class="discount-info">- ${variant.discountPercentage}% off</span>`
          : '';
  
        const priceDisplay = variant.discountPercentage
          ? `$${variant.discountedPrice.toFixed(2)}${discountInfo}`
          : `$${variant.price.toFixed(2)}`;
  
        const numericVariantId = variant.id.split('/').pop();
        const row = document.createElement('tr');
        row.innerHTML = `
          <td>${variant.title}</td>
          <td>${priceDisplay}</td> <!-- Show price with discount if available -->
          <td>${quantity}</td>
          <td>$${(variant.discountedPrice * quantity).toFixed(2)}</td> <!-- Total cost calculated based on quantity -->
          <td>within ${variant.deliveryTime} weeks</td>
          <td><button class="add-to-cart-btn" data-variant-id="${numericVariantId}" data-quantity="${quantity}" ><img src="https://cdn.shopify.com/s/files/1/0741/3376/6426/files/cal-icon.svg?v=1725318603"></button></td>
        `;
        variantsTableBody.appendChild(row);
          document.querySelectorAll('.add-to-cart-btn').forEach(button => {
            button.addEventListener('click', handleAddToCart);
        });
      });
    }
  
    // Helper functions to show/hide no results message
    function showNoResults(message, table, pagination) {
      if (message) message.style.display = 'block';
      if (table) table.style.display = 'none';
      if (pagination) pagination.style.display = 'none';
    }

    function hideNoResults(message, table, pagination) {
      if (message) message.style.display = 'none';
      if (table) table.style.display = 'table';
      if (pagination) pagination.style.display = 'block';
    }
  });
  



document.addEventListener('DOMContentLoaded', function() {
    new SlimSelect({
      select: '#collection',
      placeholder: 'Select product type',
showSearch: false,
      allowDeselect: true, // Allows users to deselect options
      searchText: 'No collections found', // Text to display when no results match search
      closeOnSelect: false // Keeps dropdown open after selection
    });
  });
document.addEventListener('DOMContentLoaded', function() {
    new SlimSelect({
      select: '#decoration',
      placeholder: 'Select decoration',
      allowDeselect: true, // Allows users to deselect options
      searchText: 'No collections found', // Text to display when no results match search
showSearch: false,
      closeOnSelect: false // Keeps dropdown open after selection
    });

  let tipspan = document.querySelector('#dialog-content-iiii');

    tippy('.tiperrr', {
      content: tipspan.innerHTML,
      allowHTML: true,
      theme: 'light'
    });
  
  });




console.log('77');


const ShareableLink = (function() {
  let searchForm;
  let copyLinkButton;

  function init() {
    searchForm = document.getElementById('product-search-form');
    copyLinkButton = document.getElementById('copy-link-button');

    if (!searchForm || !copyLinkButton) {
      console.error('Search form or copy link button not found');
      return;
    }

    copyLinkButton.addEventListener('click', copyLink);
    window.addEventListener('load', checkUrlAndSubmit);
  }

  function generateShareableLink() {
    const formData = new FormData(searchForm);
    const params = new URLSearchParams(formData);
    //return `${window.location.origin}${window.location.pathname}?${params.toString()}`;
    return `https://promopunks.com.au/pages/budget-calculator/?${params.toString()}`;
    
  }

  function copyLink() {
    const link = generateShareableLink();
    navigator.clipboard.writeText(link).then(() => {
      alert('Shareable link copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy link: ', err);
    });
  }

  function prefillFormFromURL() {
    const params = new URLSearchParams(window.location.search);
    for (const [key, value] of params) {
      const element = document.getElementById(key);
      if (element) {
        if (element.type === 'checkbox') {
          element.checked = value === 'true';
        } else if (element.tagName === 'SELECT') {
          const values = params.getAll(key);
          if (element.slim) { // Check if SlimSelect is initialized
            element.slim.setSelected(values);
          } else {
            Array.from(element.options).forEach(option => {
              option.selected = values.includes(option.value);
            });
          }
        } else {
          element.value = value;
        }
      }
    }
  }

  function checkUrlAndSubmit() {
    const params = new URLSearchParams(window.location.search);
    const requiredParams = ['collection', 'decoration', 'quantity', 'maxSpend'];
    const allParamsPresent = requiredParams.every(param => params.has(param));

    if (allParamsPresent) {
      prefillFormFromURL();
      searchForm.dispatchEvent(new Event('submit'));
    }
  }

  function showCopyLinkButton() {
    copyLinkButton.style.display = 'inline-block';
  }

  return {
    init,
    showCopyLinkButton,
    prefillFormFromURL
  };
})();

// Initialize the module when the DOM is fully loaded and SlimSelect is initialized
document.addEventListener('DOMContentLoaded', function() {
  // Check if SlimSelect is loaded and initialized
  const checkSlimSelectInterval = setInterval(function() {
    const collectionSelect = document.getElementById('collection');
    const decorationSelect = document.getElementById('decoration');
    if (collectionSelect.slim && decorationSelect.slim) {
      clearInterval(checkSlimSelectInterval);
      ShareableLink.init();
      ShareableLink.prefillFormFromURL();
    }
  }, 100); // Check every 100ms

  // Set a timeout to stop checking after 5 seconds to prevent infinite loop
  setTimeout(function() {
    clearInterval(checkSlimSelectInterval);
    if (!document.getElementById('collection').slim || !document.getElementById('decoration').slim) {
      console.error('SlimSelect not initialized after 5 seconds');
    }
  }, 5000);
});

console.log('183');